import locale from "localization/en";

export const keyAccountCollectionColumn = [
  { key: "collectionId", text: locale.collectionId },
  { key: "dateTime", text: locale.collectionDateAndTime },
  { key: "amount", text: locale.amount },
  { key: "siNumSoa", text: locale.siNumSoa },
  { key: "keyAccountName", text: locale.keyAccountName },
  { key: "paymentMethod", text: locale.paymentMethod },
  { key: "remarks", text: locale.remarks },
];
